import { Injectable } from '@angular/core';
import { actionDeleteAllProductWishList, actionDeleteAllProductWishListFailure, actionDeleteAllProductWishListSuccess, actionDeleteProductWishList, actionDeleteProductWishListFailure, actionDeleteProductWishListSuccess, countPdtWishList, countPdtWishListFailure, countPdtWishListSuccess, delPdtWishList, delPdtWishListFailure, delPdtWishListSuccess, loadPdtWishList, loadPdtWishListFailure, loadPdtWishListSuccess, savePdtWishList, savePdtWishListFailure, savePdtWishListSuccess } from '@app/actions/shoppingmall/product-wishlist.action';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ProductWishlistService } from '@app/services/shoppingmall/product-wishlist.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';

@Injectable()
export class WishListPdtEffect {
    constructor(
        private _actions$: Actions,
        private _productWishlistService: ProductWishlistService
      ) { }

    loadPdtWishList$ = createEffect(() => this._actions$.pipe(
        ofType(loadPdtWishList),
        mergeMap(({params}) => this._productWishlistService.loadPdtWishList(params).pipe(
            map(res => loadPdtWishListSuccess({items : res})),
            catchError(res => of(loadPdtWishListFailure({ msg: res})))
        ))
    ));

    loadTotalPdtWishList$ = createEffect(() => this._actions$.pipe(
        ofType(countPdtWishList),
        mergeMap(({params}) => this._productWishlistService.countPdtWishList(params).pipe(
            map(res => countPdtWishListSuccess({total : res})),
            catchError(res => of(countPdtWishListFailure({ msg: res})))
        ))
    ));

    saveTotalPdtWishList$ = createEffect(() => this._actions$.pipe(
        ofType(savePdtWishList),
        mergeMap(({userId, pdtCd}) => this._productWishlistService.savePdtWishList(pdtCd, userId).pipe(
            map(res => savePdtWishListSuccess({msg : res})),
            catchError(res => of(savePdtWishListFailure({ msg: res})))
        ))
    ));

    delTotalPdtWishList$ = createEffect(() => this._actions$.pipe(
        ofType(delPdtWishList),
        mergeMap(({userId, pdtCd}) => this._productWishlistService.delPdtWishList(pdtCd, userId).pipe(
            map(res => delPdtWishListSuccess({msg : res})),
            catchError(res => of(delPdtWishListFailure({ msg: res})))
        ))
    ));

    deleteProductWishList$ = createEffect(() => this._actions$.pipe(
      ofType(actionDeleteProductWishList),
      mergeMap(({params}) => this._productWishlistService.deleteProductWishList(params).pipe(
          map(res => {
            let map : Map<String, String> = new Map();
            map.set("code", ConvertUtil.convertToString(res.status));
            map.set("WISH_LIST_DELETE", ConvertUtil.convertToString(res.headers.get("WISH_LIST_DELETE")));
            return actionDeleteProductWishListSuccess({msgDeleteWishList : map})
          }),
          catchError(res => of(actionDeleteProductWishListFailure({ msgDeleteWishList: new Map().set("code", ConvertUtil.convertToString(res.status))})))
      ))
    ));

    deleteAllProductWishList$ = createEffect(() => this._actions$.pipe(
      ofType(actionDeleteAllProductWishList),
      mergeMap(({params}) => this._productWishlistService.deleteAllProductWishList(params).pipe(
          map(res => {
            let map : Map<String, String> = new Map();
            map.set("code", ConvertUtil.convertToString(res.status));
            map.set("WISH_LIST_DELETE", ConvertUtil.convertToString(res.headers.get("WISH_LIST_DELETE")));
            return actionDeleteAllProductWishListSuccess({msgDeleteWishList : map})
          }),
          catchError(res => of(actionDeleteAllProductWishListFailure({ msgDeleteWishList: new Map().set("code", ConvertUtil.convertToString(res.status))})))
      ))
    ));
}
